function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M13.86.5a1 1 0 011 .94v1.23H8.63A1.922 1.922 0 006.8 4.54v4.92a1.92 1.92 0 001.96 1.87h6.06v1.23a1 1 0 01-1 .94H1a1 1 0 01-1-.94V1.44A1 1 0 011 .5zm1.31 3.25a.813.813 0 01.83.79v4.92a.81.81 0 01-.83.79H8.76a.813.813 0 01-.83-.79V4.54a.81.81 0 01.83-.79zM12 6a1 1 0 100 2 1 1 0 000-2z"
});

function SvgWallet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 14
  }, props), _ref);
}

export default SvgWallet;